export default "__VITE_ASSET__9wk4HauP__"